module.exports = __webpack_public_path__ + "img/marketing-goals.b7413cd0.png";